var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-mobile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.25,
    height: 18,
    viewBox: "0 0 11.25 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mobile-alt-solid",
    d: "M9.563,0H1.688A1.688,1.688,0,0,0,0,1.688V16.312A1.688,1.688,0,0,0,1.688,18H9.563a1.688,1.688,0,0,0,1.688-1.688V1.688A1.688,1.688,0,0,0,9.563,0ZM5.625,16.875A1.125,1.125,0,1,1,6.75,15.75,1.124,1.124,0,0,1,5.625,16.875Zm3.937-3.8a.423.423,0,0,1-.422.422H2.109a.423.423,0,0,1-.422-.422V2.109a.423.423,0,0,1,.422-.422H9.141a.423.423,0,0,1,.422.422Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMobile);
export default __webpack_public_path__ + "static/media/ic-mobile.90c248523911f344a11c685640ab1a7b.svg";
export { ForwardRef as ReactComponent };